import DealerCare from "services/dealerCareApi";
import Billing from "services/billingApi";
import {
  getProviders,
  getAllProviders,
  getMerchantInfo,
} from "services/paymentApi";
import { ProviderType } from "../enums";
import type {
  DealerApiResponse,
  ProvidersApiResponse,
  AvailableProvidersRawResponse,
  MerchantInfoApiResponse,
  FetchDealerDataResults,
  PaymentMethodsApiResponse,
} from "../types";
import type { Provider } from "../components/DealerAcquirersTable/types";
import { processProvidersResult } from "../utils/processApiResults";

export async function fetchDealerData(
  dealerId: string,
): Promise<FetchDealerDataResults> {
  const settledResults = await Promise.allSettled([
    DealerCare.get(`/v1/dealers/${dealerId}`) as Promise<DealerApiResponse>,
    getProviders({ merchantId: dealerId }) as Promise<ProvidersApiResponse>,
    getAllProviders({
      types: [ProviderType.LocalPayment, ProviderType.Gateway],
    }) as Promise<AvailableProvidersRawResponse>,
    getMerchantInfo(dealerId) as Promise<MerchantInfoApiResponse>,
    Billing.get(
      `/v2/dealers/${dealerId}/paymentmethods-all-origins`,
    ) as Promise<PaymentMethodsApiResponse>,
  ]);

  const results = settledResults.map((result, index) => {
    if (result.status === "fulfilled") {
      return result.value;
    }

    switch (index) {
      case 0:
        return { data: { data: null } } as unknown as DealerApiResponse;
      case 1:
        return { data: [] } as ProvidersApiResponse;
      case 2:
        return { data: [] } as AvailableProvidersRawResponse;
      case 3:
        return { data: null } as unknown as MerchantInfoApiResponse;
      case 4:
        return { data: [] } as PaymentMethodsApiResponse;
      default:
        throw result.reason;
    }
  }) as FetchDealerDataResults;

  return results;
}

export async function fetchProviders(merchantId: string): Promise<Provider[]> {
  const response = (await getProviders({
    merchantId,
  })) as ProvidersApiResponse;
  return processProvidersResult(response);
}
